/* ================================================================
   Designer App Root - Composes the editor layout.
   Ribbon + 3D viewport + accordion inspector, in a light Tailwind
   theme consistent with the outer ERP shell.
   ================================================================ */

import { useEffect } from 'react';
import Viewport3D from './components/Viewport3D';
import Toolbar from './components/Toolbar';
import Inspector from './components/Inspector';
import ContextMenu from './components/ContextMenu';
import KeyboardShortcuts from './components/KeyboardShortcuts';
import { useEditorStore } from './state/editorStore';

export default function DesignerApp({ embedded = false }: { embedded?: boolean }) {
  const loadFromLocal = useEditorStore(s => s.loadFromLocal);

  useEffect(() => {
    if (!embedded) loadFromLocal();
  }, [loadFromLocal, embedded]);

  return (
    <div className="flex h-full w-full flex-col overflow-hidden bg-white text-walnut-900">
      <KeyboardShortcuts />
      <Toolbar />
      <div className="relative flex flex-1 overflow-hidden" data-designer-context-root="true">
        <ContextMenu />
        <div className="relative flex-1 overflow-hidden">
          <Viewport3D />
        </div>
        <div className="hidden w-80 flex-shrink-0 lg:block">
          <Inspector />
        </div>
      </div>
    </div>
  );
}
